module.exports = __webpack_public_path__ + "img/squarespace-logo.ff7ffc79.webp";